// Import components
import CreateButton from "global/components/CreateButton";
import { ImageLoader } from "global/components/ImageLoader";



const formatExpiresRemaining = (expiresValue) => {

  if (!expiresValue) return "No Expiry";

  const now = new Date();

  const expires = new Date(expiresValue);

  const diff = expires - now;

  if (diff <= 0) return "Expired";

  const seconds = Math.floor(diff / 1000);

  const minutes = Math.floor(diff / (1000 * 60));

  const hours = Math.floor(diff / (1000 * 60 * 60));

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (days > 0) return `${days} day${days > 1 ? "s" : ""}`;

  if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""}`;

  if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""}`;

  return `${seconds} second${seconds !== 1 ? "s" : ""}`;

};



const CompletedQueueSection = ({
  selectedQueueDayGroup,
  getQueueItemIdentity,
  getOutputEntries,
  getQueueItemPromptDisplay,
  onOpenFocusImage,
  onDeleteImage,
}) => {

  return (

    <div className="ai-images-container">

      {/* Empty state when there are no completed/non-running items for the selected day. */}
      {!selectedQueueDayGroup ? (

        <p>No queue items to show.</p>

      ) : (

        /* Render only the currently selected day group from the slider. */
        [selectedQueueDayGroup].map(({ dayKey, label, images: groupedImages }) => (

          <section key={dayKey} style={{ marginBottom: "2rem" }}>

            {/* Day heading for the selected queue group. */}
            <h3 className="ai-image-date-heading">{label}</h3>

            <div className="ai-image-grid">

              {groupedImages.map((img, index) => (

                  <div
                    key={getQueueItemIdentity(img) || `${img?.created || "unknown"}-${img?.workflow_id || img?.workflow_code || "workflow"}-${index}`}
                    className="ai-image-cell"
                  >

                    {!img.error_message && !img.image_url && getOutputEntries(img.output).length > 0 ? (

                      /* Non-image outputs open the focus popup and show output details there. */
                      <div
                        className="ai-image-wrapper ai-image-wrapper--queue ai-output-wrapper"
                        onClick={() => {

                          onOpenFocusImage(img);

                        }}
                      >

                        <div className="ai-output-card">

                          <div className="ai-output-card-title">{getQueueItemPromptDisplay(img)}</div>

                          <div className="ai-output-card-grid">

                            {getOutputEntries(img.output).map((entry) => (

                              <div key={`output-${getQueueItemIdentity(img) || index}-${entry.key}`} className="ai-output-field">

                                <div className="ai-output-field-label">{entry.label}</div>

                                <div className="ai-output-field-value">{entry.value}</div>

                              </div>

                            ))}

                          </div>

                        </div>

                      </div>

                    ) : (

                      /* Regular generated image card. */
                      <div className="ai-image-wrapper ai-image-wrapper--queue ai-completed-image-card">

                        {/* Keep the image title permanently visible above the image. */}
                        <div
                          className="ai-completed-image-card__title"
                          title={getQueueItemPromptDisplay(img) || "Untitled"}
                        >

                          {getQueueItemPromptDisplay(img) || "Untitled"}

                        </div>

                        {/* Main preview hit area opens popup details. */}
                        <div
                          className="ai-queue-image-hit-area"
                          onClick={() => {

                            onOpenFocusImage(img);

                          }}
                        >

                          <ImageLoader
                            src={img.thumbnail_url || img.image_url}
                            alt={getQueueItemPromptDisplay(img) || "AI generated image"}
                            className="ai-image-thumbnail"
                          />

                        </div>

                        {/* Keep the normal image actions and remaining lifetime underneath the image. */}
                        <div className="ai-completed-image-card__actions">

                          <div className="ai-completed-image-card__actions-left">

                            {/* Use the standard portal delete button and icon. */}
                            <CreateButton
                              icon="/images/icon_bin.png"
                              iconTitle="Delete"
                              tooltip="Delete image"
                              size="xs"
                              isDelete={true}
                              onClick={() => {

                                onDeleteImage(img.job);

                              }}
                            />

                          </div>

                          <div className="ai-completed-image-card__actions-right">

                            {/* Show how long this generated item remains available. */}
                            <div
                              className="ai-completed-image-card__expires"
                              title="Time remaining"
                            >

                              <svg viewBox="0 0 16 16" aria-hidden="true">

                                <circle cx="8" cy="8" r="7" />

                                <line x1="8" y1="8" x2="8" y2="4" />

                                <line x1="8" y1="8" x2="11" y2="8" />

                              </svg>

                              <span>{formatExpiresRemaining(img.expires)}</span>

                            </div>

                          </div>

                        </div>

                      </div>

                    )}

                </div>

              ))}

            </div>

          </section>

        ))

      )}

    </div>

  );

};

export default CompletedQueueSection;



